import { css, cx } from '@emotion/css';
import { FC, ReactNode, useEffect, useRef, useState } from 'react';
import { checkSupportWebm } from '@/utils';

export interface VideoFramesPlayerPropsType {
    height?: number;
    scrollRatio?: number;
    delayRatio?: number;
    url: string;
    webmUrl?: string;
    onProgress?: (progress: number) => void;
    children?: ReactNode;
    cancelSticky?: boolean;
}
/**
 * @props url - - 视频地址
 * @props height - - 组件高度 单位vh,如 100 = 100vh
 * @props scrollRatio - - 滚动高度比例 x*100vh,如 1 = 1 * 100vh
 * @props delayRatio - - 延迟滚动高度比例 x*100vh,如 1 = 1 * 100vh
 * @returns
 */
const ScrollStickyVideo: FC<VideoFramesPlayerPropsType> = ({
    height = 100,
    scrollRatio = 1,
    delayRatio = 0,
    url,
    webmUrl = url,
    onProgress,
    children,
    cancelSticky = false,
}) => {
    const scrollBoxElem = useRef(null);
    const scrollElem = useRef<HTMLDivElement>(null);
    const playerElem = useRef<HTMLVideoElement>();
    const boxheight = height * (scrollRatio + 1);
    const duration = (boxheight - height) / height;
    const [loading, setLoading] = useState(true);
    // const finalyUrl = checkSupportWebm() ? webmUrl : url;

    useEffect(() => {
        let controller;
        let scene: any;

        if (typeof window !== 'undefined') {
            (async () => {
                const ScrollMagic = (await import('scrollmagic')).default;
                const blobUrl = await transformToBob(url, webmUrl);
                setLoading(false);
                if (playerElem.current) {
                    const video = playerElem.current;
                    video.src = blobUrl;
                    controller = new ScrollMagic.Controller();
                    const offset = (scrollElem.current?.clientHeight || 0) * delayRatio;
                    scene = new ScrollMagic.Scene({
                        triggerElement: scrollBoxElem.current, //触发元素
                        offset,
                        triggerHook: 'onLeave',
                        duration: `${(duration - delayRatio) * 100}%`,
                    });

                    scene.on('progress', function ({ progress }: any) {
                        if (video.duration) {
                            video.currentTime = video.duration * progress;
                        }
                        onProgress && onProgress(progress);
                    });
                    controller.addScene(scene);
                }
            })();
        }

        return () => {
            scene && scene.destroy();
        };
    }, []);

    return (
        <div
            ref={scrollBoxElem}
            className={css`
                width: 100%;
                height: ${loading ? height : boxheight}vh;
            `}
        >
            <div
                className={css`
                    position: ${loading || cancelSticky ? 'inherit' : 'sticky'};
                    top: 0;
                    left: 0;
                `}
            >
                <div
                    ref={scrollElem}
                    className={css`
                        width: 100%;
                        height: ${height}vh;
                        position: relative;
                    `}
                >
                    <div
                        className={cx(
                            'ScrollStickyVideo-video',
                            !cancelSticky
                                ? css`
                                      width: 100%;
                                      position: absolute;
                                      left: 50%;
                                      font-size: 0;
                                      top: 50%;
                                      transform: translate(-50%, -50%);
                                  `
                                : css``,
                        )}
                    >
                        <video
                            ref={playerElem as any}
                            className={css`
                                width: 100%;
                            `}
                        ></video>
                    </div>
                    {children && (
                        <div
                            className={cx(
                                'ScrollStickyVideo-children',
                                css`
                                    width: 100%;
                                    position: absolute;
                                    left: 50%;
                                    top: 50%;
                                    transform: translate(-50%, -50%);
                                    z-index: 1;
                                `,
                            )}
                        >
                            {children}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

function transformToBob(url: string, webmUrl: string): Promise<string> {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    let finalyUrl = '';
    // safari 不支持 webm blob
    if (isSafari || !checkSupportWebm()) {
        // safari 下 webm 背景色不对改用mp4
        finalyUrl = url;
    } else {
        finalyUrl = webmUrl || url;
    }

    return new Promise((resolve, reject) => {
        const req = new XMLHttpRequest();
        req.open('GET', finalyUrl, true);
        req.responseType = 'blob';
        req.onload = async function () {
            if (this.status === 200) {
                const videoBlob = this.response;
                const blobSrc = URL.createObjectURL(videoBlob);
                console.log('blobSrc加载完毕', finalyUrl);
                resolve(blobSrc);
            } else {
                reject();
            }
        };
        req.onerror = reject;
        req.send();
    });
}

export default ScrollStickyVideo;
